import React from "react";

function DescendingIcon({ isActive }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M5.12199 9.97698V1.18398C5.12199 1.09116 5.08512 1.00213 5.01948 0.936497C4.95384 0.870859 4.86482 0.833984 4.77199 0.833984H3.14099C3.04834 0.834249 2.95957 0.871241 2.89415 0.93685C2.82873 1.00246 2.79199 1.09133 2.79199 1.18398V9.97798H1.44999C1.31204 9.97856 1.17732 10.0199 1.06278 10.0968C0.948234 10.1737 0.858965 10.2827 0.806184 10.4102C0.753403 10.5376 0.739465 10.6779 0.766118 10.8132C0.792772 10.9486 0.85883 11.073 0.955994 11.171L3.46199 13.677C3.59319 13.8077 3.77082 13.881 3.95599 13.881C4.14117 13.881 4.3188 13.8077 4.44999 13.677L6.95599 11.171C7.05316 11.073 7.11922 10.9486 7.14587 10.8132C7.17252 10.6779 7.15859 10.5376 7.1058 10.4102C7.05302 10.2827 6.96375 10.1737 6.84921 10.0968C6.73467 10.0199 6.59995 9.97856 6.46199 9.97798H5.12199V9.97698Z"
        fill={`${isActive ? "#2F5E8A" : "#9497A9"}`}
      />
    </svg>
  );
}

export default DescendingIcon;
